import { Component } from 'react';
import './SearchResultHeader.scss';
import { SearchContext } from '../../context/SearchContext';
import {
  ArrowUp32Filled as ArrowUpIcon,
  ArrowDown32Filled as ArrowDownIcon,
} from '@fluentui/react-icons';
import { Button, Dropdown, Option } from '@fluentui/react-components';
import { connectTeamsTheme } from "./../../context/connectTeamsTheme";

interface SorterConfigItem {
  displayName: string;
  name: string;
}

interface SearchSettings {
  sortOrder: 'asc' | 'desc';
  sortBy: string;
  skip: number;
  [key: string]: any;
}

interface SearchResults {
  documentCount: number;
  totalCount: number;
  [key: string]: any;
}

interface SearchResultsHeaderProps {
  searchSettings: SearchSettings;
  searchResults: SearchResults;
  sorterConfig: SorterConfigItem[];
  styles: { theme: { button: string } };
}

class SearchResultsHeader extends Component<SearchResultsHeaderProps> {
  static contextType = SearchContext;
  context!: { isExecutingSearch: boolean; updateSorting: (sortBy: string, sortOrder: string) => void };

  getSortOrderIcon = () => {
    if (this.props.searchSettings.sortOrder === "asc") {
      return <ArrowUpIcon />;
    } else {
      return <ArrowDownIcon />;
    }
  };

  onSortOrderClick = () => {
    let sortOrder: 'asc' | 'desc' = "asc";
    if (this.props.searchSettings.sortOrder === "asc") {
      sortOrder = "desc";
    }
    const searchContext = this.context;
    searchContext.updateSorting(this.props.searchSettings.sortBy, sortOrder);
  };

  onSortByChange = (_: any, data: { optionValue?: string }) => {
    const searchContext = this.context;
    searchContext.updateSorting(data.optionValue ?? '', this.props.searchSettings.sortOrder);
  };

  render() {
    const sorterOptions = [] as { header: string; name: string }[];
    for (let i = 0; i < this.props.sorterConfig.length; i++) {
      const sorter = this.props.sorterConfig[i];
      sorterOptions.push({ header: sorter.displayName, name: sorter.name });
    }
    const searchContext = this.context;
    const headerText = searchContext.isExecutingSearch
      ? 'Searching...'
      : `${this.props.searchSettings.skip + 1}-${this.props.searchSettings.skip + this.props.searchResults.documentCount} of ${this.props.searchResults.totalCount} results`;
    return (
      <header className="wrapper-header display--flex flex--wrap">
        <p className="title">{headerText}</p>
        <div className="support-sorters-panel display--flex">
          <p className="sorter-title">Sort by:</p>
          <Dropdown
            defaultValue={sorterOptions[1] ? sorterOptions[1].header : sorterOptions[0]?.header}
            onOptionSelect={this.onSortByChange}
          >
            {sorterOptions.map(option => (
              <Option key={option.name} value={option.name}>
                {option.header}
              </Option>
            ))}
          </Dropdown>
          <Button
            appearance="transparent"
            className={this.props.styles.theme.button}
            onClick={this.onSortOrderClick}
            icon={this.getSortOrderIcon()}
            title="Change sorting order"
          />
        </div>
      </header>
    );
  }
}

const SearchResultHeader = connectTeamsTheme(SearchResultsHeader);
export default SearchResultHeader;
